export class VillageTransportRequest{
    villageTransportCostId:number
    VillageName:string;
    TransportaionCost:number
    
   
    constructor(
        villageTransportCostId:number,
        VillageName:string,
        TransportaionCost:number
       
    ){
       this.villageTransportCostId = villageTransportCostId
       this.VillageName = VillageName
       this.TransportaionCost = TransportaionCost
       
    }
}
export class VillageTransportRequestDto{
    data:VillageTransportRequest[]
    user:string
    constructor(
        data:VillageTransportRequest[],
        user:string 
    )
    {
        this.data = data
        this.user = user
    }
}